import React from "react";
import { Container, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import configuration from "react-global-configuration";
import "./HeaderIndex.css"
import api from "../../../Environment";

const MobileHeader = () => {
    return (
        <header className="mobile-header">
            <Container className="d-flex justify-content-center align-items-center">
                <Link to="/home">
                    <Image
                        src={api.serviceUrl() +
                            "/" + configuration.get("configData.site_logo")}
                        className="mobile-logo-image"
                        alt="logo"
                    />
                </Link>
            </Container>
        </header>
    )
}

export default MobileHeader;
